import { createFileRoute } from "@tanstack/react-router";
import ViewAdmin from "@/pages/admins/view-admin";
import PrivateLayout from "@/components/layouts/private-layout";

export const Route = createFileRoute("/_authenticated/admins/$adminId")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <ViewAdmin />
    </PrivateLayout>
  );
}
